import { useState, useCallback } from 'react'
import {
  ApplicationBodyContainer,
  ApplicationBodyContent,
  DefaultTitle,
  GreenContainer,
  GreenContainerQuestionWrapper,
  ClaimsContainer
} from '../../../components/application/defaultComponents'
import ApplicationPrebuiltFooter from '../../../components/application/PrebuiltBodyFooter'
import { useApplication } from '../../../context/application'
import { LeftBar } from 'src/components/basic/LeftBar'
import { FlexDiv } from 'src/components/application/formComponents/styles'
import StepBullet from 'src/components/basic/StepBullet'
import OptionButton from 'src/components/basic/OptionButton'
import ClaimItemForm from 'src/components/application/formComponents/ClaimItemForm'
import flagWithCheckImg from 'src/assets/applicationFormsImgs/flag_with_check.svg'
import { ClaimData } from 'src/dtos/applicationData'
import Button from 'src/components/basic/Button'
import { string } from 'yup'

const Claims = () => {
  const newAttorneyClaimsErrorCodes = ['EC270', 'EC271', 'EC272', 'EC273', 'EC274', 'EC275', 'EC276', 'EC277', 'EC278', 'EC279', 
                                       'EC280', 'EC281', 'EC282', 'EC283', 'EC284', 'EC285', 'EC286', 'EC287', 'EC288', 'EC289',
                                       'EC290', 'EC291', 'EC292', 'EC293', 'EC294', ] //25
  const { application } = useApplication()
  const [claims, setClaims] = useState<ClaimData[]>(() => {
    return application?.liabilitySection?.pastLiability?.claims || [{}]
  })
  const [isIncorrect, setIsIncorrect] = useState(false)
  const [hasMalpracticeClaim, setHasMalpracticeClaim] = useState(() => {
    if(application?.liabilitySection?.pastLiability) {
      const { hasMalpracticeClaim } = application.liabilitySection.pastLiability

      return {
        isVisible: !!hasMalpracticeClaim,
        value: hasMalpracticeClaim
      }
    }
    return { isVisible: false, value: false }
  })
  const [hasMalpracticeBasis, setHasMalpracticeBasis] = useState(() => {
    if(application?.liabilitySection?.pastLiability) {
      const { hasMalpracticeBasis } = application.liabilitySection.pastLiability

      return {
        isVisible: !!hasMalpracticeBasis,
        value: hasMalpracticeBasis
      }
    }
    return { isVisible: false, value: false }
  })

  const isAllSet = () => {
    return !hasMalpracticeClaim.value && !hasMalpracticeBasis.value
  }

  const updateClaims = useCallback((index: number, data: Partial<ClaimData>) => {
    setClaims(prev => prev.map((pv, idx) => idx === index ? { ...pv, ...data } : pv))
  }, [])

  const handleAddAnotherClaim = () => {
    setClaims(prev => [...prev, {}])
  }

  const updatedApplicationData = () => ({ 
    ...application,
    currentPage: window.location.pathname,
    liabilitySection: {
      ...application.liabilitySection,
      pastLiability: {
        ...application.liabilitySection?.pastLiability,
        hasMalpracticeClaim: hasMalpracticeClaim.value,
        hasMalpracticeBasis: hasMalpracticeBasis.value,
        claims
      }
    }
  })

  const validatePage = () => {
    const validation = claims.map(claim => {
      try {
        if(!!claim?.claimDate) {
          //string().trim().length(10).validDate('Invalid Date').validateSync(claim?.claimDate)
        }
        if(!!claim?.allegedErrorDate) {
          //string().trim().length(10).validDate('Invalid Date').validateSync(claim?.allegedErrorDate)
        }
        return true
      } catch(e) {
        return false
      }
    })

    return !validation.some(valid => valid === false)
  }

  return (
    <ApplicationBodyContainer>
      <ApplicationBodyContent width='80%'>
        <DefaultTitle>Please fill out the following regarding your claim.</DefaultTitle>
        <GreenContainer>
          <div className='green-container-content'>
            <h6>You’re being asked to fill out this supplemental claim information based on your answers to the following questions.</h6>
            <span>If this information is incorrect, please change your answers.</span>
            <div>
              <LeftBar />
              <GreenContainerQuestionWrapper>
                {hasMalpracticeClaim.isVisible ? (
                  <div className='green-container-question-div'>
                    <StepBullet>2</StepBullet>
                    <FlexDiv dir='column' gap="24px">
                      <p>
                        In the past 10 years, has your firm or any lawyer at your
                        firm been the subject of a legal malpractice claim?
                      </p>
                      <FlexDiv gap="16px">
                        <OptionButton
                          checked={hasMalpracticeClaim.value === true}
                          onChange={() => setHasMalpracticeClaim(prev => ({ ...prev, value: true }))}
                        >
                          Yes
                        </OptionButton>
                        <OptionButton
                          checked={hasMalpracticeClaim.value === false}
                          onChange={() => setHasMalpracticeClaim(prev => ({ ...prev, value: false }))}
                        >
                          No
                        </OptionButton>
                      </FlexDiv>
                    </FlexDiv>
                  </div>
                ) : null}
                {hasMalpracticeBasis.isVisible ? (
                  <div className='green-container-question-div'>
                    <StepBullet>3</StepBullet>
                    <FlexDiv dir='column' gap="24px">
                      <p>
                        Does any firm member or non-attorney employee of your 
                        firm (including predecessor firms) know of any circumstance,
                        act, error, or omission that might form the basis of a 
                        legal malpractice claim against your firm? Or any 
                        attorney in your firm?
                      </p>
                      <FlexDiv gap="16px">
                        <OptionButton
                          checked={hasMalpracticeBasis.value === true}
                          onChange={() => setHasMalpracticeBasis(prev => ({ ...prev, value: true }))}
                        >
                          Yes
                        </OptionButton>
                        <OptionButton
                          checked={hasMalpracticeBasis.value === false}
                          onChange={() => setHasMalpracticeBasis(prev => ({ ...prev, value: false }))}
                        >
                          No
                        </OptionButton>
                      </FlexDiv>
                    </FlexDiv>
                  </div>
                ) : null}
              </GreenContainerQuestionWrapper>
            </div>
          </div>
        </GreenContainer>
        {isAllSet() ? (
          <GreenContainer>
            <div className='claim-all-set'>
              <div className='claim-all-set-icon'>
                <img src={flagWithCheckImg} alt="All Set" />
              </div>
              <div className='claim-all-set-message'>
                <h3>All Set!</h3>
                <h4>You no longer need to complete this section.</h4>
              </div>
            </div>
          </GreenContainer>
        ) : (
          <ClaimsContainer>
            <span className='claims-form-header-subtitle'>PLEASE FILL OUT THE FOLLOWING TO THE BEST OF YOUR ABILITY</span>
            <span className='claims-form-header-subtitle'>If you do not know, leave blank.</span>
            {claims.map((claim, index) => (
              <ClaimItemForm
                key={index}
                claim={claim}
                claimIndex={index}
                attorneys={application?.attorneysSection?.attorneys}
                setClaim={(data) => updateClaims(index, data)}
                isIncorrect={isIncorrect && !validatePage()}
                errorCodes={newAttorneyClaimsErrorCodes.map(e => `${e}:${index}`)}
              />
            ))}
            <div className='claims-add-button'>
              <Button variant='secondary' onClick={handleAddAnotherClaim}>
                Add another claim
              </Button>
            </div>
          </ClaimsContainer>
        )}
      </ApplicationBodyContent>
      <ApplicationPrebuiltFooter
        goBackRoute="/insurance/past-liability"
        nextRoute="/quote/type"
        updatedApplication={updatedApplicationData()}
        isFormValid={validatePage()}
        beforeSaveContinueClick={() => !validatePage() ? setIsIncorrect(true) : null}
      />
    </ApplicationBodyContainer>
  )
}

export default Claims